/**
 * Base component class for AEM frontend components.
 * Provides a foundation for creating interactive UI components by automatically
 * extracting data attributes and calling initialization logic.
 * This class is extended by all AEM components during initialization.
 *
 * @example
 * // Register with CSS selector
 * registerComponent('.my-component', MyComponent);
 *
 * @example
 * // Register with specific element
 * const element = document.getElementById('hero');
 * registerComponent(element, HeroComponent);
 *
 * @example
 * // Register with NodeList and custom context
 * const elements = document.querySelectorAll('.modal');
 * registerComponent(elements, ModalComponent, document.body);
 */


export class Component {
    /**
     * Creates a new component instance and initializes it.
     *
     * @param {HTMLElement} element - The DOM element to associate with this component
     */
    constructor(element) {
        this.element = element;
        this.props = this.element.dataset;
        this.init();
    }

    init() {
    }
}

/**
 * Registers and initializes components for matching DOM elements.
 * Supports multiple selector types and automatically instantiates the specified component class.
 *
 * @param {string|HTMLElement|NodeList} selector - CSS selector string, single element, or NodeList
 * @param {Function} ComponentClass - Component class constructor to instantiate
 * @param {Document|Element} [context=document] - Context element for selector queries (optional)
 */

export function registerComponent(selector, ComponentClass, context = document) {
    let elements;
    if (NodeList.prototype.isPrototypeOf(selector)) {
        elements = selector;
    } else if (selector instanceof HTMLElement) {
        elements = [ selector ];
    } else if (typeof selector === 'string') {
        elements = context.querySelectorAll(selector);
    }
    elements.forEach(element => {
        new ComponentClass(element);
    });
}
